import React from 'react';
import PropTypes from 'prop-types';
import TdLink from './TdLink';
import {Message} from '@aperza/ui';

export default class FooterNavBarItem extends React.Component {

  static propTypes = {
    messageId: PropTypes.string,
    href: PropTypes.string,
    openOnNewTab: PropTypes.bool,
    showExternalLink: PropTypes.bool,
  };

  render() {
    return (
      <TdLink action="td-parts-serviceLinks"
              openOnNewTab={this.props.openOnNewTab}
              anchorMessageId={this.props.messageId}
              className="naviLink naviLink-footer"
              href={this.props.href} >
        <Message messageId={this.props.messageId} />
        {this.props.showExternalLink && <div style={{display: 'inline'}} className="external-link" />}
      </TdLink>
    )
  }

}
